<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" label-width="100px"
        class="demo-ruleForm">
        <el-form-item label="告警规则名称" prop="alarmName">
          <el-input v-model="ruleForm.alarmName" placeholder="请输入告警规则名称" style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="告警规则描述" prop="alarmDescribe">
          <el-input type="textarea" :rows="4" v-model="ruleForm.alarmDescribe" placeholder="请输入告警规则描述"
            style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="告警级别" prop="alarmLevel">
          <el-select v-model="ruleForm.alarmLevel" placeholder="请选择" style="width: 80%;">
            <el-option v-for="item in levelData" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知方式" prop="notifications">
          <el-checkbox-group v-model="ruleForm.notifications">
            <el-checkbox label="1">短信</el-checkbox>
            <el-checkbox label="2">邮箱</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="短信通知" prop="phones"
          v-if="ruleForm.notifications.length>0&&ruleForm.notifications.includes('1')">
          <el-input v-model="ruleForm.phones" style="width: 80%;" placeholder="请输入短信通知手机号码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱通知" prop="emails"
          v-if="ruleForm.notifications.length>0&&ruleForm.notifications.includes('2')">
          <el-input v-model="ruleForm.emails" style="width: 80%;" placeholder="请输入通知的邮箱"></el-input>
        </el-form-item>
        <el-form-item label="关联触发场景" prop="ruleEngineId">
          <el-select v-model="ruleForm.ruleEngineId" placeholder="请选择" style="width: 80%;">
            <el-option v-for="item in scenesData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  export default {
    data() {
      return {
        dialogVisible: false,
        title: "",
        ruleForm: {
          alarmName: '',
          alarmDescribe: '',
          alarmLevel: '',
          phones: '',
          emails: '',
          ruleEngineId: '',
          notifications: [],
        },
        rules: {
          alarmName: [{
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }],
          alarmLevel: [{
            required: true,
            message: "请选择告警级别",
            trigger: "change"
          }],
          phones: [{
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          }],
          emails: [{
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          }],
          ruleEngineId: [{
            required: true,
            message: "请选择关联的场景",
            trigger: "change"
          }]
        },
        levelData: [
          { value: 1, label: '紧急' },
          { value: 2, label: '重要' },
          { value: 3, label: '次要' },
          { value: 4, label: '提示' },
        ],
        scenesData: [],
      }
    },
    methods: {
      resetForm() {

      },
      show(val) {
        this.dialogVisible = true
        this.reset()
        this.getAllRule()
      },
      showEdit(val) {
        this.ids = val
        this.dialogVisible = true
        this.getAllRule()
        this.getConfigDet(this.ids)
      },
      // 表单重置
      reset() {
        this.ruleForm = {
          alarmName: '',
          alarmDescribe: '',
          alarmLevel: '',
          phones: '',
          emails: '',
          ruleEngineId: '',
          notifications: [],
        },
          this.resetForm("ruleForm");
      },
      getAllRule() {
        API.platformRuleConfigList().then(res => {
          if (res.code === 1) {
            this.scenesData = res.data.result
          }
        })
      },
      getConfigDet() {
        API.platformAlarmConfigDet(this.ids).then(res => {
          if (res.code === 1) {
            this.ruleForm = res.data
            if (this.ruleForm.notifications == null) {
              this.ruleForm.notifications = []
            } else {
              this.ruleForm.notifications = this.ruleForm.notifications.split(",");
            }

          }
        })
      },
      /** 提交按钮 */
      submitForm() {
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            this.notifications = this.ruleForm.notifications
            this.ruleForm.notifications = this.notifications.join(',')
            if (this.ruleForm.notifications == ['1']) {
              this.ruleForm.emails = ""
            } else if (this.ruleForm.notifications == ['2']) {
              this.ruleForm.phones = ""
            } else if (this.ruleForm.notifications == []) {
              this.ruleForm.phones = ""
              this.ruleForm.emails = ""
            }
            console.log(this.ruleForm)
            // return
            if (this.ruleForm.id != null) {
              API.platformAlarmConfigEdit(this.ids, this.ruleForm).then(response => {
                if (response.code === 1) {
                  this.$message.success("修改成功");
                  this.dialogVisible = false
                  this.$parent.getconfigList();
                }
              });
            } else {

              API.platformAlarmConfigAdd(this.ruleForm).then(response => {
                if (response.code === 1) {
                  this.popupAdd = false;
                  this.$message.success("新增成功");
                  this.dialogVisible = false
                  this.$parent.getconfigList();
                }
              });
            }
          }
        });
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/views/platform/alarmAdd.vue